import * as React from "react";
import { Search, X } from "lucide-react";
import { Input } from "./input";
import { cn } from "@/lib/utils";

export interface SearchInputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  onClear?: () => void;
}

export const SearchInput = React.forwardRef<HTMLInputElement, SearchInputProps>(
  ({ className, type, value, onClear, onKeyDown, ...props }, ref) => {
    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
      if ((e.metaKey || e.ctrlKey) && e.key === "a") {
        e.stopPropagation();
        return;
      }

      if (onKeyDown) {
        onKeyDown(e);
      }
    };

    return (
      <div
        className={cn(
          "flex items-center w-full h-8 p-2 bg-secondary-n-950 rounded-lg text-secondary-n-700 border border-secondary-n-950 transition-all",
          "focus-within:border-primary-0",
          className,
        )}
      >
        <Search className="size-5 text-secondary-n-700 transition-all" />
        <Input
          placeholder="Search..."
          className="border-none focus-visible:ring-0 bg-transparent pl-2 text-xs text-text-primary placeholder:text-secondary-n-700 rounded-md"
          value={value}
          onKeyDown={handleKeyDown}
          ref={ref}
          variant="search"
          {...props}
        />
        {value && onClear && (
          <X
            className="size-4 text-secondary-n-700 hover:text-white cursor-pointer"
            onClick={onClear}
          />
        )}
      </div>
    );
  },
);

SearchInput.displayName = "SearchInput";
